import React from "react";

const variants = {
  default:
    "border-[var(--color-border)] text-ink-muted dark:text-slightwhite/70",
  azure: "border-azure/30 bg-azure/5 text-azure dark:border-electric/30 dark:bg-electric/10 dark:text-electric",
  solid: "border-transparent bg-ink text-paper dark:bg-slightwhite dark:text-ink",
};

const Tag = ({ children, variant = "default", className = "" }) => (
  <span
    className={`inline-flex items-center rounded-full border px-3 py-1 font-mono text-[10px] uppercase tracking-[0.16em] ${
      variants[variant] || variants.default
    } ${className}`}
  >
    {children}
  </span>
);

export default Tag;
